/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_M_OwnersInputs */

const es_nav_m_owners = /** @type {(inputs: Nav_M_OwnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armadores`)
};

const gl_nav_m_owners = /** @type {(inputs: Nav_M_OwnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armadores`)
};

const en_nav_m_owners = /** @type {(inputs: Nav_M_OwnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boat owners`)
};

/**
* | output |
* | --- |
* | "Boat owners" |
*
* @param {Nav_M_OwnersInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_m_owners = /** @type {((inputs?: Nav_M_OwnersInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_M_OwnersInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_m_owners(inputs)
	if (locale === "en") return en_nav_m_owners(inputs)
	return es_nav_m_owners(inputs)
});